<template>
  <b-container fluid>
    <b-row>
      <b-col class="col-lg-9" offset="3">
        <h2 class="text-left">{{title}}</h2>
        <b-alert :show="loading" variant="info">Bezig met laden...</b-alert>
        <b-alert v-model="errorMessageVisible" variant="danger" dismissible>{{errorMessage}}</b-alert>
      </b-col>
    </b-row>
    <b-row v-if="logging">
      <b-col cols="9" offset="3">
        <b-form class="border" style="width: 50%; padding:4px">
            <b-form-row>
              <b-col cols="12">
                <b-form-group label="Datum:"
                              label-for="logged"
                              label-cols="4"
                              content-cols="8">
                  <b-form-input id="logged"
                                v-bind:value="loggedInDateTimeFormat"
                                disabled />
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col cols="12">
                <b-form-group label="Level:"
                              label-for="level"
                              label-cols="4"
                              content-cols="8">
                  <b-form-input id="level"
                                v-model="logging.level"
                                disabled />
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col cols="12">
                <b-form-group label="Bron:"
                              label-for="logger"
                              label-cols="4"
                              content-cols="8">
                  <b-form-input id="logger"
                                v-model="logging.logger"
                                disabled />
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col cols="12">
                <b-form-group label="Machinenaam:"
                              label-for="machineName"
                              label-cols="4"
                              content-cols="8">
                  <b-form-input id="machineName"
                                v-model="logging.machineName"
                                disabled />
                </b-form-group>
              </b-col>
            </b-form-row>

            <b-form-group>
            </b-form-group>

            <b-form-row>
              <b-col cols="12">
                <b-form-group label="Bericht:"
                              label-for="message">
                  <b-form-textarea id="message"
                                   v-model="logging.message"
                                   rows="3"
                                   style="overflow-y: auto"
                                   disabled />
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col cols="12">
                <b-form-group label="Foutdetails:"
                              label-for="exception">
                  <b-form-textarea id="exception"
                                   v-model="logging.exception"
                                   rows="4"
                                   style="overflow-y: auto"
                                   disabled />
                </b-form-group>
              </b-col>
            </b-form-row>


            <b-form-row class="mt-3">
              <b-col cols="0" offset="0">
                <b-button v-on:click="back" variant="primary" class="float-right mr-1">Terug</b-button>
              </b-col>
            </b-form-row>
        </b-form>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
  import ErrorHandlerMixin from '@/mixins/ErrorHandlerMixin'

  export default {
    name: 'LoggingDetail',
    mixins: [ErrorHandlerMixin],
    data() {
      return {
        title: 'Loggingdetails',
        loading: false,
        logging: null,
      }
    },
    created: function () {
      if (this.loggingId !== -1) {
        this.loadDetails(this.loggingId)
      }
      else {
        this.logging = {}
      }
    },
    props: {
      loggingId: Number
    },
    methods: {
      loadDetails(id) {
        this.$api.get('logging/' + id)
          .then((response) => {
            this.logging = response.data
          })
          .catch((error) => {
            this.logging = null

            this.handleHttpError(error, 'Er ging iets fout bij het ophalen van de logdetails.')
          })
      },
      back() {
        this.$router.push({ name: 'logging' })
      }
    },
    computed: {
      loggedInDateTimeFormat: function () {
        return new Date(this.logging.logged).toLocaleString()
      }
    }
  }
</script>
